
import { Component, Vue } from "vue-property-decorator";
import ReportsHeader from "@/components/reports/ReportsHeader.vue";
import ReportsTable from "@/components/reports/ReportsTable.vue";
import IconReport from "@/components/common/icon/IconReports.vue";
import WarningModal from "@/components/common/WarningModal.vue";
import { Getter } from "vuex-class";
import { ICountryConfig } from "@/entities";

@Component({
  name: "reports-page",
  components: {
    ReportsHeader,
    ReportsTable,
    IconReport,
    WarningModal,
  },
})
export default class ReportsPage extends Vue {
  @Getter("getCountryConfig") countryConfig: ICountryConfig | undefined;

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    if (this.countryConfig?.Reports.ShowWarning) {
      this.$nextTick(() => {
        this.$bvModal.show("warning-modal");
      });
    }
  }
}
